import React from 'react';
import { useStyles } from './device-icon-styles';
import { DeviceType } from 'src/common/enumerations/device-type';
import { ReactComponent as CustomerDisplay } from 'src/common/media/desktop-mac.svg';
import { ReactComponent as UnknownDevice } from 'src/common/media/device-unknown.svg';
import { ReactComponent as CashDrawer } from 'src/common/media/cash-office.svg';
import { ReactComponent as PinPad } from 'src/common/media/keypad.svg';
import { ReactComponent as Micr } from 'src/common/media/micr.svg';
import { ReactComponent as Printer } from 'src/common/media/print.svg';
import { ReactComponent as Scanner } from 'src/common/media/scan.svg';
import { ReactComponent as Scale } from 'src/common/media/weight.svg';

export interface Props {
  type?: DeviceType;
  operational?: boolean;
  className?: string;
}

const testIdPrefix = 'device-icon';

const DeviceIcon: React.FC<Props> = (props: Props): JSX.Element => {
  const { type, operational, className: optionalClassName } = props;
  const classes = useStyles({ operational });
  const className = `${classes.root} ${optionalClassName}`;

  switch (type) {
    case DeviceType.CCL:
      return <PinPad data-testid={`${testIdPrefix}-pin-pad`} className={className} />;
    case DeviceType.CashDrawer:
      return <CashDrawer data-testid={`${testIdPrefix}-cash-drawer`} className={className} />;
    case DeviceType.CustomerDisplay:
      return (
        <CustomerDisplay data-testid={`${testIdPrefix}-customer-display`} className={className} />
      );
    case DeviceType.MICR:
      return <Micr data-testid={`${testIdPrefix}-micr`} className={className} />;
    case DeviceType.Printer:
      return <Printer data-testid={`${testIdPrefix}-printer`} className={className} />;
    case DeviceType.Scale:
      return <Scale data-testid={`${testIdPrefix}-scale`} className={className} />;
    case DeviceType.Scanner:
      return <Scanner data-testid={`${testIdPrefix}-scanner`} className={className} />;
    default:
      return <UnknownDevice data-testid={`${testIdPrefix}-unknown-device`} className={className} />;
  }
};

export default DeviceIcon;
